module.exports = __webpack_public_path__ + "img/total_trailers.b338e7ee.svg";